__turbopack_context__.v({
  "card": "card-module__gZjlZq__card",
  "default": "card-module__gZjlZq__default",
  "primary": "card-module__gZjlZq__primary",
  "text": "card-module__gZjlZq__text",
  "title": "card-module__gZjlZq__title",
});
